import { CChartBar } from '@coreui/react-chartjs'
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react-pro'
import React from 'react'
import Loader from 'src/components/Loader'
import useChartData from './useChartData'

const BarChart = () => {
  const {
    loading,
    formattedData,
    formattedWksData,
    formattedFourData,
    formattedSixesData,
    formattedMdnsData,
    formattedFpData,
    formattedTwData,
    formattedPsData,
    formattedPmData,
    formattedGcdData,
    formattedYcdData,
    formattedRcdData,
    formattedCstData,
    formattedP60Data,
    formattedP60PlusData,
  } = useChartData()

  return loading ? (
    <Loader />
  ) : (
    <CRow>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Goal</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedData} labels="Goal Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>GK Saves</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedWksData} labels="GK Saves Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Own Goal</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedFourData} labels="Own Goal Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Assist</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedSixesData} labels="Assist Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Penalty Saves</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedPsData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Penalty Miss</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedPmData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Green Card</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedGcdData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Yellow Card</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedYcdData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Red Card</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedRcdData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Clean Sheet</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedCstData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Played 60mins</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedP60Data} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Played 60mins Plus</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedP60PlusData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Fantasy Points</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedFpData} labels="Fantasy Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default BarChart
